import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Button } from "@circleco/compass/components/Button";
import { Suspense, type ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";

const CompassGoLiveModal = lazyWithRetry(() =>
  import(/* webpackChunkName: "CompassGoLiveModal" */ "./index").then(
    module => ({ default: module.CompassGoLiveModal }),
  ),
);

/** Lazy boundary so CreateEventModal stays off the initial graph. */
export const LazyCompassGoLiveModal = ({
  triggerSize,
  ...props
}: ComponentPropsWithoutRef<typeof CompassGoLiveModal>) => (
  <Suspense
    fallback={
      // Controlled mode (`open` set) renders no trigger, so the placeholder
      // would flash a button that never exists once the chunk resolves.
      props.open !== undefined ? null : (
        <Button
          startIcon="video"
          size={triggerSize}
          variant="outline"
          fullWidth
          disabled
          className="pointer-events-none"
        >
          {t("sidebar_footer_v3.go_live")}
        </Button>
      )
    }
  >
    <CompassGoLiveModal triggerSize={triggerSize} {...props} />
  </Suspense>
);
